export default __webpack_public_path__ + "static/HES-SO_INTERVIEWS_FREDERIC-775a04d8f9306d6da0fb24d9e1e2e404.jpg";